import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import shareholderRegistered from "../../../../assets/shareholder-registered.svg";
import "../../../../components/share-holders/share-holders.scss";
const DirectorRegistered = ({
  setActiveIndex,
  resetRegData,
  setIsCongrats,
  registeredDirector,
}) => {
  const navigate = useNavigate();
  const { entityid } = useParams();

  const closeWizard = () => {
    navigate(`/entity/${entityid}/appointments-ownership?tab=directors`, {
      state: { skipBlocker: true },
    });
  };

  const handleNewDirector = () => {
    setActiveIndex(0);
    setIsCongrats(false);
    resetRegData();
  };

  return (
    <div className="formgrid grid flex justify-content-center align-item-center">
      <div className="no-key-container">
        <img
          src={shareholderRegistered}
          alt="director-registered"
          className="file-upload-logo"
        />

        <div className="no-key-align">
          <p className="shareholder-registered my-2">Director registered</p>
          <p className="drag-drop-text mt-0 mb-4">
            {registeredDirector?.name} {registeredDirector?.last_name} is now
            officially registered
          </p>
        </div>

        <div className="inline-flex gap-3">
          <button className="add-new-shareholder" onClick={handleNewDirector}>
            Add New Appointment <span className="pi pi-plus ml-2"></span>
          </button>

          <button
            type="button"
            className="cancel-btns close-wizard"
            onClick={closeWizard}
          >
            Close Wizard
          </button>
        </div>
      </div>
    </div>
  );
};

export default DirectorRegistered;
